<template>
  <div>
    <canvas id="canvas"   class="main-canvas"></canvas>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: {
    title: String,
    color: String
  },
  watch: {
    title () {
      this.reDraw()
    }
  },
  mounted () {
    this.reDraw()
  },
  methods: {
    reDraw () {
      let canvas = document.getElementById('canvas')
      let context = canvas.getContext('2d')
      canvas.width = canvas.width
      context.scale(1.6, 0.8)
      let text = this.title
      // 绘制印章边框
      let width = canvas.width * 0.5
      let height = canvas.height * 0.5
      context.rotate(-20 * Math.PI / 180)
      context.translate(-width / 2, height / 2) // 移动坐标原点
      context.lineWidth = 1
      context.strokeStyle = this.color
      context.beginPath()
      context.arc(width, height, width * 0.45, 0, Math.PI * 2)
      context.stroke()
      context.fillStyle = '#ffffff'
      context.fill()
      context.lineWidth = 1
      context.strokeStyle = this.color
      context.beginPath()
      context.arc(width, height, width * 0.35, 0, Math.PI * 2)
      context.stroke()
      // 画五角星
      let fiveStarR = width * 0.3
      for (var i = 0; i < 20; i++) {
        // 角度 angle
        let rA = (Math.PI / 8.0) * i
        let rx = width - fiveStarR * Math.cos(rA)
        let ry = height - fiveStarR * Math.sin(rA)
        this.create5star(context, rx, ry, 3, this.color, rA - Math.PI / 2)
      }
      // 画矩形
      this.drawRoundedRect(context, this.color, 'white', width * 0.5, width * 0.36, width, width / 3.5, 10) // -90*Math.PI/180
      // 绘制印章名称
      context.font = '28px Helvetica'
      context.textBaseline = 'middle'// 设置文本的垂直对齐方式
      context.textAlign = 'center' // 设置文本的水平对对齐方式
      context.lineWidth = 1
      context.strokeStyle = this.color
      context.strokeText(text, width, width / 2)
    },
    /**
     * 创建一个五角星形状. 该五角星的中心坐标为(sx,sy),中心到顶点的距离为radius,rotate=0时一个顶点在对称轴上
     * rotate:绕对称轴旋转rotate弧度
     */
    create5star (context, sx, sy, radius, color, rotato) {
      context.save()
      context.fillStyle = color
      context.translate(sx, sy) // 移动坐标原点
      context.rotate(Math.PI + rotato) // 旋转
      context.beginPath() // 创建路径
      var dig = Math.PI / 5 * 4
      for (var i = 0; i < 5; i++) { // 画五角星的五条边
        let x = Math.sin(i * dig)
        let y = Math.cos(i * dig)
        context.lineTo(x * radius, y * radius)
      }
      context.closePath()
      context.stroke()
      context.fill()
      context.restore()
    },
    roundedRect (context, cornerX, cornerY, width, height, cornerRadius) {
      if (width > 0) {
        context.moveTo(cornerX + cornerRadius, cornerY)
      } else {
        context.moveTo(cornerX - cornerRadius, cornerY)
      }
      /* arcTo(x0, y0, x1, y1, radius) */
      context.arcTo(cornerX + width, cornerY,
        cornerX + width, cornerY + height,
        cornerRadius)
      context.arcTo(cornerX + width, cornerY + height,
        cornerX, cornerY + height,
        cornerRadius)
      context.arcTo(cornerX, cornerY + height,
        cornerX, cornerY,
        cornerRadius)
      if (width > 0) {
        context.arcTo(cornerX, cornerY,
          cornerX + cornerRadius, cornerY,
          cornerRadius)
      } else {
        context.arcTo(cornerX, cornerY,
          cornerX - cornerRadius, cornerY,
          cornerRadius)
      }
    },
    drawRoundedRect (context, strokeStyle, fillStyle, cornerX, cornerY, width, height, cornerRadius) {
      context.save()
      context.beginPath()
      this.roundedRect(context, cornerX, cornerY, width, height, cornerRadius)
      context.strokeStyle = strokeStyle
      context.fillStyle = fillStyle
      context.closePath()
      context.stroke()
      context.fill()
      context.restore()
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '../css/var'
.main-canvas
  width 100%
  height pt(250)
</style>



// WEBPACK FOOTER //
// stamp.vue?471a0d4a